module.exports = __webpack_public_path__ + "img/W-G06.0275af1c.jpg";